/* import __COLOCATED_TEMPLATE__ from './legal-page.hbs'; */
import Component from '@glimmer/component';
import styles from './legal-page.module.scss';

export default class LegalPage extends Component {
  styles = styles;
}
